/** 可由前端安全识别并请求删除的七牛公开域名。 */
export const QINIU_PUBLIC_MEDIA_HOSTS = [
  "pic.yishulvxing.com/",
  "7x00b8.com2.z0.glb.qiniucdn.com/",
] as const;

/** 与后端 `MEDIA_MAX_BYTES` 默认值对齐的图片上传上限。 */
export const MEDIA_IMAGE_MAX_BYTES = 12 * 1024 * 1024;

/** 通用文件（含 PPT）上传上限；后端 `kind=file` 使用同一口径。 */
export const MEDIA_FILE_MAX_BYTES = 50 * 1024 * 1024;
